import { render, staticRenderFns } from "./SupplierContactsTab.vue?vue&type=template&id=26b43398&scoped=true&"
import script from "./SupplierContactsTab.vue?vue&type=script&lang=js&"
export * from "./SupplierContactsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b43398",
  null
  
)

export default component.exports